import { Flex } from '@grupoboticario/flora-react'
import { IMagazineShortcut } from 'src/@interfaces'
import { MagazineShortcut } from 'src/components/atoms'

export type MagazineShortcutsVariants = 'mobile' | 'desktop'

export interface MagazineShortcutsProps {
  /**
   * Array com uma lista de pageIDs
   */
  values?: number[]
  options: IMagazineShortcut[]
  variant?: MagazineShortcutsVariants
  onClick?: (shortcut: IMagazineShortcut, checked: boolean, position: number) => void
}

export const MagazineShortcuts = ({
  options,
  values = [],
  variant = 'mobile',
  onClick,
}: MagazineShortcutsProps) => {
  const isMobile = variant === 'mobile'

  const isChecked = (shortcut: IMagazineShortcut) => values.includes(shortcut.page)

  const handleClick = (shortcut: IMagazineShortcut, position: number) => () => {
    // Aqui adicionamos mais um ao índice pois a primeira página é o tutorial
    onClick?.(shortcut, !values.includes(shortcut.page), position + 1)
  }

  return (
    <Flex
      as="ul"
      aria-label="Lista de atalhos"
      direction="row"
      gap="$1"
      css={{
        lineHeight: isMobile ? '26px' : '24px',
        maxWidth: '100vw',
        overflowX: 'scroll',
        padding: '0 $2',
        width: '100%',
        '&::-webkit-scrollbar': {
          display: 'none',
        },
      }}
      wrap={isMobile ? 'nowrap' : 'wrap'}
    >
      {options.map((shortcut, index) => (
        <Flex
          as="li"
          key={shortcut.id}
          align="center"
        >
          <MagazineShortcut
            checked={isChecked(shortcut)}
            label={shortcut.label}
            variant={variant}
            onClick={handleClick(shortcut, index)}
          />
        </Flex>
      ))}
    </Flex>
  )
}
